import React, { useState, useEffect } from "react";
import "./ConsultationLog.css";
import { FaPlus, FaRegNoteSticky } from "react-icons/fa6";
import { FiEdit } from "react-icons/fi";
import FamilyConsultation from "./FamilyConsultation";
import AddNotes from "./AddNotes";
import FamilyConsultationReadOnly from "./FamilyConsultationReadOnly";
import FamilyMedicineTable from "./FamilyMedicineTable";
import { get } from "../../utility/fetch2";
import BirthRecordForm from "./BirthRecordForm";
import IVFConsultationTable from "./IVFConsultationTable";
import OrthopedicTable from "./OrthopedicTable";
import GeneralSurgery from "./GeneralSurgery";
import GeneralSurgeryTable from "./GeneralSurgeryTable";
import GeneralPractice from "./GeneralPracticeTable";
import OpthalmologyTable from "./OpthalmologyTable";
import AntinatalTable from "./AntinatalTable";
import CardiologyTable from "./CardiologyTable";
import { fileFromPath } from "openai";
import AllOtherPracticesTable from "./AllOtherPracticesTable";

const MedicalLog = ({ patient }) => {
  const [selectedSection, setSelectedSection] = useState("");
  const [newSpecialists, setNewSpecialists] = useState([]);
  const [selectedNewSpecialists, setSelectedNewSpecialists] = useState(null);
  const [visibleOptions, setvisibleOptions] = useState([]);
  const [FamilyMedicine, setFamilyMedicine] = useState([]);
  const [OG_IVF, setOG_IVF] = useState([]);
  const [orthopedic, setorthopedic] = useState([]);
  const [GeneralSurgery, setGeneralSurgery] = useState([]);
  const [Antenatal, setAntenatal] = useState([]);
  const [generalPracticeState, setGeneralPracticeState] = useState([]);
  const [opthalmology, setOpthalmology] = useState([]);
  const [cardiology, setcardiology] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // console.log(patient);
    getAvailableSIdebar(patient?.id);
  }, []);

  useEffect(() => {
    getSpecialist();
  }, []);

  //   const getPatientDetails = async () => {
  //     setLoading(true);
  //     try {
  //       const data = await get(`/FamilyMedicine/list/1/10`);
  //       setPatient(data);
  //       console.log(data);
  //       console.log(data?.id);
  //       setVisit(data?.visits?.pop());
  //     } catch (e) {
  //       console.log(e);
  //     }
  //     setLoading(false);
  //   };

  //   useEffect(() => {
  //     getPatientDetails();
  //   }, []);

  const logs = [
    {
      date: "02.04.2025",
      type: "Case Note",
      history: "Family Planning Consultation Analysis",
      doctor: "Dr. Williams Humphrey",
    },
    {
      date: "02.04.2025",
      type: "Follow-up Consultation",
      history: "Family Planning Consultation Analysis",
      doctor: "Dr. Williams Humphrey",
    },
  ];

  const getAvailableSIdebar = async (patient) => {
    setLoading(true);

    // Create an array of all your promises with error handling
    const promises = [
      get(`/GeneralPractice/list/patient/${patient}/${1}/10`).catch((err) => {
        console.log("GeneralPractice endpoint error:", err);
        return null;
      }),
      get(`/cardiology/list/patient/${patient}/${1}/10`).catch((err) => {
        console.log("Cardiology endpoint error:", err);
        return null;
      }),
      get(`/OG_IVF/list/patient/${patient}/${1}/10`).catch((err) => {
        console.log("OG_IVF endpoint error:", err);
        return null;
      }),
      get(`/orthopedic/list/patient/${patient}/${1}/10`).catch((err) => {
        console.log("Orthopedic endpoint error:", err);
        return null;
      }),
      get(`/GeneralSurgery/list/patient/${patient}/${1}/10`).catch((err) => {
        console.log("GeneralSurgery endpoint error:", err);
        return null;
      }),
      get(`/Antenatal/list/patient/${patient}/${1}/10`).catch((err) => {
        console.log("Antenatal endpoint error:", err);
        return null;
      }),
      get(`/FamilyMedicine/list/patient/${patient}/${1}/10`).catch((err) => {
        console.log("FamilyMedicine endpoint error:", err);
        return null;
      }),
      get(`/Ophthalmology/list/patient/${patient}/${1}/10`).catch((err) => {
        console.log("Ophthalmology endpoint error:", err);
        return null;
      }),
    ];
    try {
      // Wait for all promises to resolve
      const [
        GeneralPracticeArrayResponse,
        cardiologyResponse,
        IvfResponse,
        orthopedicResponse,
        GeneralSurgeryResponse,
        AntenatalResponse,
        FamilyMedicineResponse,
        OphthalmologyResponse,
      ] = await Promise.all(promises);

      // Once all are resolved, set your states
      const ivfData = IvfResponse?.data?.recordList || [];
      const orthopedicData = orthopedicResponse?.data?.recordList || [];
      const generalSurgeryData = GeneralSurgeryResponse?.data?.recordList || [];
      const antenatalData = AntenatalResponse?.data?.recordList || [];
      const familyMedicineData = FamilyMedicineResponse?.data?.recordList || [];
      const generalPracticeData =
        GeneralPracticeArrayResponse?.data?.recordList || [];
      const ophthalmologyData = OphthalmologyResponse?.data?.recordList || [];
      const cardiologyData = cardiologyResponse?.data?.recordList || [];

      console.log("=== RAW API RESPONSES ===");
      console.log("GeneralPractice Response:", GeneralPracticeArrayResponse);
      console.log("Cardiology Response:", cardiologyResponse);
      console.log("IVF Response:", IvfResponse);
      console.log("Orthopedic Response:", orthopedicResponse);
      console.log("GeneralSurgery Response:", GeneralSurgeryResponse);
      console.log("Antenatal Response:", AntenatalResponse);
      console.log("FamilyMedicine Response:", FamilyMedicineResponse);
      console.log("Ophthalmology Response:", OphthalmologyResponse);

      setOG_IVF(ivfData);
      setorthopedic(orthopedicData);
      setGeneralSurgery(generalSurgeryData);
      setAntenatal(antenatalData);
      setFamilyMedicine(familyMedicineData);
      setGeneralPracticeState(generalPracticeData);
      setOpthalmology(ophthalmologyData);
      setcardiology(cardiologyData);

      // NOW all operations have finished loading
      console.log("=== ALL SIDEBAR DATA LOADED ===");
      console.log("General Practice Data:", generalPracticeData);
      console.log("General Practice Count:", generalPracticeData.length);

      // Build the state map with the fetched data
      const stateMap = {
        familymedcine: familyMedicineData,
        ivf: ivfData,
        orthopedic: orthopedicData,
        generalsurgery: generalSurgeryData,
        atenatal: antenatalData,
        generalPractice: generalPracticeData,
        opthalmology: ophthalmologyData,
        cardiology: cardiologyData,
      };

      // Define base sections
      const baseSections = [
        { key: "familymedcine", label: "Family Planning", idz: 0 },
        { key: "ivf", label: "O&G IVF", idz: 0 },
        { key: "opthalmology", label: "Opthalmology", idz: 0 },
        { key: "orthopedic", label: "Orthopedic", idz: 0 },
        { key: "atenatal", label: "O&G Antenatal/Post-natal", idz: 0 },
        { key: "generalsurgery", label: "General Surgery", idz: 0 },
        { key: "generalPractice", label: "General Practice", idz: 0 },
        { key: "cardiology", label: "Cardiology", idz: 0 },
      ];

      // Filter sections that have data
      const sectionsWithData = baseSections.filter((opt) => {
        const stateValue = stateMap[opt.key];
        return stateValue && stateValue.length > 0;
      });

      console.log("Sections with data:", sectionsWithData);

      // Set visible options immediately after fetching
      setvisibleOptions(sectionsWithData);

      // Auto-select the first specialty if data exists
      if (sectionsWithData.length > 0) {
        setSelectedSection(sectionsWithData[0]);
      }

      setLoading(false);

      // You can also set a loading state to false here
      // setLoading(false); // If you have a loading state
    } catch (error) {
      setLoading(false);
      console.error("Error loading sidebar data:", error);
      // Handle errors, e.g., show an error message to the user
      // setError(true); // If you have an error state
    }
  };

  const [selectedRecords, setSelectedRecords] = useState([]);

  const handleSelectChange = (e) => {
    const selectedValue = e.target.value;

    console.log(selectedValue);

    const temp = sections.find((temps) => temps.key == e.target.value);

    const filterChecker = visibleOptions.find((k) => k.key == temp.key);
    console.log(temp);
    setSelectedNewSpecialists(temp);

    if (filterChecker) {
      alert("Already on List");
    } else setvisibleOptions([...visibleOptions, temp]);

    // console.log([
    //   ...visibleOptions,
    //   { key: selectedValue.toLowerCase(), value: selectedValue },
    // ]);

    // console.log(filteredOptions);

    //   const optionsMap = {
    //   familymedcine: FamilyMedicine,
    //   ivf: OG_IVF,
    //   Orthopedic: orthopedic,
    //   generalsurgery: GeneralSurgery,
    //   atenatal: Antenatal,
    //   generalPractice: generalPracticeState,
    //   cardiology: cardiology,
    // };

    //   setSelectedRecords(optionsMap[selectedValue] || []);
  };
  const renderComponent = () => {
    switch (selectedSection.key) {
      case "familymedcine":
        return <FamilyMedicineTable patient={patient} />;
      case "birthrecord":
        return <BirthRecordForm patient={patient} />;
      case "ivf":
        return <IVFConsultationTable patient={patient} />;
      case "orthopedic":
        return <OrthopedicTable patient={patient} />;
      case "generalsurgery":
        return <GeneralSurgeryTable patient={patient} />;
      case "atenatal":
        return <AntinatalTable patient={patient} />;
      case "generalPractice":
        return <GeneralPractice patient={patient} />;
      case "opthalmology":
        return <OpthalmologyTable patient={patient} />;
      case "cardiology":
        return <CardiologyTable patient={patient} />;

      default:
        return selectedSection ? (
          <AllOtherPracticesTable
            selectedSpecialists={selectedSection}
            patient={patient}
          />
        ) : (
          ""
        );
    }
  };

  const getSpecialist = async () => {
    try {
      const response = await get(`/RoleSpecialist/list`);
      if (response.isSuccess) {
        // Filter out unwanted specialist names
        const filtered = response.data
          .filter((e) => e.role.name === "Doctor")
          .filter(
            (e) =>
              e.specialistService !== "Ophthalmologist" &&
              e.specialistService !== "Cardiologist" &&
              e.specialistService !== "General Surgeon" &&
              e.specialistService !== "Family Planning" &&
              e.specialistService !== "O&G IVF" &&
              e.specialistService !== "Opthalmology" &&
              e.specialistService !== "Orthopedic" &&
              e.specialistService !== "O&G Antenatal/Post-natal" &&
              e.specialistService !== "General Surgery" &&
              e.specialistService !== "General Practice" &&
              e.specialistService !== "Cardiology",
          );

        setNewSpecialists(filtered);
        console.log(filtered);
      }
    } catch (error) {
      console.error("Failed to fetch specialists:", error);
    }
  };

  const sections = [
    { key: "familymedcine", label: "Family Planning", idz: 0 },
    { key: "ivf", label: "O&G IVF", idz: 0 },
    { key: "opthalmology", label: "Opthalmology", idz: 0 },
    { key: "orthopedic", label: "Orthopedic", idz: 0 },
    { key: "atenatal", label: "O&G Antenatal/Post-natal", idz: 0 },
    { key: "generalsurgery", label: "General Surgery", idz: 0 },
    { key: "generalPractice", label: "General Practice", idz: 0 },
    { key: "cardiology", label: "Cardiology", idz: 0 },
    ...newSpecialists.map((spec) => ({
      idz: spec?.specialistService?.toLowerCase().replace(/\s+/g, ""),
      label: spec.specialistService,
      key: spec.id,
    })),
    // { key: "pediatrics", label: "Pediatrics" },
  ];

  return (
    <div className="w-100 consultation-page">
      <div>
        <div>
          <select
            className="border px-4 py-2 rounded"
            onChange={handleSelectChange}
            defaultValue=""
            style={{
              width: "100%",
              maxWidth: "300px",
              fontSize: "clamp(0.8rem, 2.5vw, 1rem)",
              padding: "8px 12px",
            }}
          >
            <option value="" disabled>
              Add Specialty Type
            </option>
            {sections
              ?.slice() // copy so we don't mutate original array
              ?.sort((a, b) =>
                (a.label || "")?.localeCompare(b?.label || "", "en", {
                  sensitivity: "base",
                }),
              )
              ?.map((e) => (
                <option key={e.key ?? e.idz} value={e.key}>
                  {e.label}
                </option>
              ))}
          </select>

          {/* <div className="mt-4">
          <h2 className="font-bold">Selected Records:</h2>
          <pre>{JSON.stringify(selectedRecords, null, 2)}</pre>
        </div> */}
        </div>
        <div
          className="m-t-10"
          style={{
            display: "flex",
            alignItems: "start",
            flexWrap: "wrap",
            gap: "15px",
            flexDirection: window.innerWidth < 600 ? "column" : "row",
          }}
        >
          <div
            className="consultation-sidebar"
            style={{
              flex: "1 1 200px",
              minWidth: window.innerWidth < 600 ? "100%" : "150px",
              maxWidth: window.innerWidth < 600 ? "100%" : "250px",
            }}
          >
            <ul style={{ padding: 0, margin: 0 }}>
              {visibleOptions?.map((section) => (
                <li
                  key={section.key}
                  className={
                    selectedSection.key === section.key ? "active" : ""
                  }
                  onClick={() => setSelectedSection(section)}
                  style={{
                    fontSize: "clamp(0.75rem, 2.5vw, 0.9rem)",
                    padding: "10px 12px",
                    cursor: "pointer",
                  }}
                >
                  {section.label}
                </li>
              ))}
            </ul>
          </div>
          <div
            style={{ flex: "1 1 300px", minWidth: "280px", overflowX: "auto" }}
          >
            {loading ? <p>Loading patient details...</p> : renderComponent()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MedicalLog;
